import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js";

class SkioBABDiscount extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;

      font-family: var(--typeBasePrimary), var(--typeBaseFallback);
    }

    .progress-bar {
      padding: 16px 12px;
      background: #f9f9f9;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    progress {
      width: 100%;
      -webkit-appearance: none;
      appearance: none;
      background-color: #dcdcdc;
      height: 8px;
      border-radius: 0.5rem;
      overflow: hidden;
    }

    ::-webkit-progress-bar {
      background-color: #dcdcdc;
    }

    ::-webkit-progress-value {
      background-color: #ff0b0b;
    }

    ::-moz-progress-bar {
      background-color: #ff0b0b;
    }

    .savings-progress::-webkit-progress-value {
      background-color: #5b5;
    }

    .savings-progress::-moz-progress-bar {
      background-color: #5b5;
    }

    .progress-bar__tier {
      display: flex;
      flex-direction: column;
      gap: 4px;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
    }

    .progress-bar__tier p {
      font-size: 14px;
      margin: 0;
      text-align: center;
    }

    .currentTier {
      color: #5b5;
    }

    .progress-bar__tier p:only-child {
      margin: auto;
    }

    a {
      text-decoration: underline;
      cursor: pointer;
    }
  `;

  static properties = {
    boxProductId: { type: String },
    productCount: { type: Number },
    box: { state: true },
  };

  constructor() {
    super();
    this.productCount = 0;
    this.minimumProductCount = 7;
  }

  async connectedCallback() {
    super.connectedCallback();

    this.box = await this.getBoxData();
  }

  render() {
    if (!this.box) return;

    return html`
      <div class="progress-bar">
        <div class="progress-bar__tier">
          ${this.productCount < this.minimumProductCount
            ? html`Choose ${this.minimumProductCount}+ meals`
            : ""}
          ${this.getNextTier() && this.productCount >= this.minimumProductCount
            ? html`
                <p class="nextTier">
                  Add ${this.getNextTier().items - this.productCount} more meals
                  and save ${this.getNextTier().discount}%
                  ${this.productCount < 10 ? html`+ FREE shipping` : ""}
                </p>
              `
            : ""}
          ${!this.getNextTier() && this.getCurrentTier()
            ? html`
                <p class="currentTier">
                  Unlocked ${this.getCurrentTier().discount}% off + FREE
                  Shipping
                </p>
              `
            : ""}
          ${this.getNextTier() && this.getCurrentTier()
            ? html`
                <p class="currentTier">
                  Unlocked ${this.getCurrentTier().discount}% off + FREE
                  Shipping
                </p>
              `
            : ""}
        </div>

        <progress
          .value=${this.getBoxProgress()}
          max="100"
          class="${this.productCount >= this.minimumProductCount
            ? "savings-progress"
            : ""}"
        ></progress>
      </div>
    `;
  }

  getNextTier() {
    const { percentDiscountTier } = this.box;

    const nextTier = Object.keys(percentDiscountTier).find((tier) => {
      return tier > this.productCount;
    });

    if (!nextTier) return;

    return {
      items: nextTier,
      discount: percentDiscountTier[nextTier],
    };
  }

  getCurrentTier() {
    const { percentDiscountTier } = this.box;

    const currentTier = Object.keys(percentDiscountTier).findLast((tier) => {
      return this.productCount >= tier;
    });

    if (!currentTier) return;

    return {
      items: currentTier,
      discount: percentDiscountTier[currentTier],
    };
  }

  getBoxProgress() {
    const { percentDiscountTier } = this.box;
    const lastTier =
      this.productCount < this.minimumProductCount
        ? this.minimumProductCount
        : Object.keys(percentDiscountTier).pop();

    return (this.productCount / lastTier) * 100;
  }

  getBoxData() {
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem("skio-box-data")) {
        const boxData = JSON.parse(sessionStorage.getItem("skio-box-data"));

        return resolve(JSON.parse(sessionStorage.getItem("skio-box-data")));
      }

      fetch("https://api.skio.com/storefront-http/get-dynamic-box", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productPlatformId: this.boxProductId,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log("🟡 Response from API:", response);
          if (!response.ok) {
            throw new Error(response);
          }

          const { DynamicBox } = response;
          sessionStorage.setItem("skio-box-data", JSON.stringify(DynamicBox));
          console.log(
            "🟡 Stored box data in sessionStorage",
            JSON.stringify(DynamicBox, null, 2),
          );
          return resolve(DynamicBox);
        })
        .catch((error) => {
          this.error("Failed to get box data", this.boxProductId, error);
          console.error("🔴 Error fetching box data:", error);
          return reject(error);
        });
    });
  }
}

customElements.define("skio-bab-discount", SkioBABDiscount);
